module.exports = __webpack_public_path__ + "media/3-11.6dcf6c8d.wav";